import BizApiErrorConverterStrategyInterface from "./BizApiErrorConverterStrategyInterface";

class BizApiAxiosErrorConverterStrategy extends BizApiErrorConverterStrategyInterface {
    constructor(getter) {
        super();
        this.getter = getter;
    }

    convert = (error) => {
        const http_status = this.getter.safeGet(() => error.response.status.toString(), "");
        const code = this.getter.safeGet(() => error.response.data.error.code, "SYSTEM_ERROR");
        const context_code = this.getter.safeGet(() => error.response.data.error.context_code, "");
        return {
            _http_status: http_status,
            code,
            context_code,
            is_error: true
        }
    }
}

export default BizApiAxiosErrorConverterStrategy;